var map = {
	"./sms-credit-de.html": 1939,
	"./sms-credit-en.html": 1940,
	"./sms-credit-es.html": 1941,
	"./sms-credit-fr.html": 1942,
	"./sms-credit-ja.html": 1943,
	"./sms-credit-pt.html": 1944,
	"./sms-credit-zh.html": 1945
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1938;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/help/sms-credit ^\.\/sms\-credit\-.*\.html$
// module id = 1938
// module chunks = 0